import { getMutationTypesForService } from 'shared/utils/createServiceStore.js';
import { API_KEY_SERVICE_KEY } from './apiKeyEnum.js';

export default getMutationTypesForService(API_KEY_SERVICE_KEY);
